import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { CommonConfirmationModalData } from 'src/app/components/common/common-confirmation-modal/common-confirmation-modal.component.model';
import { DropdownOption } from 'src/app/components/common/common-dropdown/common-dropdown.component.model';

@Component({
  selector: 'app-dataset-filter-input-config',
  templateUrl: './dataset-filter-input-config.component.html',
  styleUrls: ['./dataset-filter-input-config.component.scss'],
  standalone: false
})
export class DatasetFilterInputConfigComponent  {

  @Input() form!: UntypedFormGroup;
  @Input() allowFiltering: boolean;
  @Input() filterFields: any[] = [];
  @Input() columnOptions: any[] = [];

  @Output() allowFilteringChanged = new EventEmitter<boolean>();
  @Output() saveFilterInput = new EventEmitter<any>();
  @Output() filterSaved = new EventEmitter<any>();
  @Output() deleteFilterInput = new EventEmitter<any>();

  get resolvedColumnOptions(): DropdownOption[] {
    if (this.columnOptions?.length) {
      return this.columnOptions;
    }

    return [
      {
        label: '(Add Column to Data Set)',
        value: '__no_columns__',
        disabled: true
      }
    ];
  }

  filterColumns = [
    {
      key: 'name',
      label: 'Column',
      headerType: 'text',
      cellType: 'text',
      sortable: true,
      hideMenu: false,
    },
    {
      key: 'label',
      label: 'Label',
      headerType: 'text',
      cellType: 'text',
      sortable: true,
      hideMenu: false,
    },
    {
      key: 'requireInput',
      label: 'Required',
      headerType: 'text',
      cellType: 'text',
      sortable: true,
      hideMenu: false,
    },
    {
      key: 'settings',
      label: 'Settings',
      headerType: 'text',
      cellType: 'icon',
      icon: 'settings',
      sortable: true,
      hideMenu: false,
    },
    {
      key: 'delete',
      label: 'Delete',
      headerType: 'text',
      cellType: 'icon',
      icon: 'delete',
      sortable: true,
      hideMenu: false,
    }
  ];  
  showOverlayEditor: boolean = false;
  requiredSlider: boolean = false;

  deleteFilterRow: any;
  deleteConfirmModal: CommonConfirmationModalData = {
    open: false,
    yesNoBtn: true,
    status: 'info',
    replaceYesWith: 'DELETE',
    replaceNoWith: 'CANCEL'
  };

  constructor(private cd: ChangeDetectorRef) { }
  

  
  ngAfterViewInit() {
    this.cd.detectChanges();
  }
  openFilterInput() {
    this.editingIndex = -1;
    this.form.reset({
      field: '',
      label: '',
      isRequired: false,
      searchField: ''
    });
    this.requiredSlider = false;
    this.showOverlayEditor = true;
  }

  close() {
    this.showOverlayEditor = false;
  }

  requiredSliderChanged(event: any) {
    this.requiredSlider = event;
  }

  save() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const existingFilter =
      this.editingIndex > -1 ? this.filterFields[this.editingIndex] : null;

    const filter = {
      ...(existingFilter || {}),
      name: this.form.value.field,
      label: this.form.value.label,
      requireInput: this.form.value.isRequired,
      searchFields: existingFilter?.searchFields || [],
      mappings: existingFilter?.mappings || [],
      showListForSelection: existingFilter?.showListForSelection ?? false,
      allowListSelection: existingFilter?.allowListSelection ?? false,
      isParcelNumber: existingFilter?.isParcelNumber ?? false,
      isPermitNumber: existingFilter?.isPermitNumber ?? false
    };
    // if (this.editingIndex > -1) {
    //   this.filterFields[this.editingIndex] = filter;
    // } else {
    //   this.filterFields.push(filter);
    // }

    this.filterSaved.emit({
      filter,
      index: this.editingIndex
    });
    this.resetEditor();
  }

  resetEditor() {
    this.editingIndex = -1;
    this.form.reset({
      field: '',
      label: '',
      isRequired: false
    });
    this.requiredSlider = false;
    this.showOverlayEditor = false;
  }

  handleIconClick(event: any) {
    if (event.icon === 'settings') {
      this.openEditOverlay(event.row);
    }
    if (event.icon === 'delete') {
      // this.deleteFilter(event.row);
      this.deleteFilterRow = event.row;
      this.openDeleteConfirmationModal();
    }
  }

  editingIndex: number = -1;

  openEditOverlay(row: any) {
    this.editingIndex = this.filterFields.findIndex(
      f => f.name === row.name
    );
    this.form.patchValue({
      field: row.name,
      label: row.label,
      isRequired: row.requireInput ?? row.required
    });
    this.requiredSlider = row.requireInput ?? row.required;
    this.showOverlayEditor = true;
  }

  deleteFilter() {
    this.deleteFilterInput.emit(this.deleteFilterRow);
  }

  openDeleteConfirmationModal() {
    this.deleteConfirmModal = {
      open: true,
      modalDescp: 'Delete Filter Input',
      modalSubDescp: `Are you sure you want to delete?`,
      replaceYesWith: 'DELETE',
      replaceNoWith: 'CANCEL'
    };
  }

}
